import { Action } from "@ngrx/store";
import { ReportParameter } from '../../../shared/models/report-parameter.model';

export const GET_CR_REPORT_PARAMETER_LIST = 'Get CR Report Parameters List';
export const GET_CR_REPORT_PARAMETER_LIST_SUCCESS = 'Get CR Report Parameters List Success';
export const GET_CR_REPORT_PARAMETER_LIST_FAIL = 'Get CR Report Parameters List Fail';

export class GetCRReportParametersList implements Action {
  readonly type = GET_CR_REPORT_PARAMETER_LIST;
  constructor(public payload: { institutionId: number } = null) { }
}

export class GetCRReportParametersListSuccess implements Action {
  readonly type = GET_CR_REPORT_PARAMETER_LIST_SUCCESS;
  constructor(public payload: ReportParameter) { }
}

export class GetCRReportParametersListFail implements Action {
  readonly type = GET_CR_REPORT_PARAMETER_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export type SSRSParametersActions =
  | GetCRReportParametersList
  | GetCRReportParametersListSuccess
  | GetCRReportParametersListFail
  ;
